import { z } from "zod";
import { BooleanQueryParamSchema } from "./common.js";

// CLP/Device: cadastro + ingestão em lote por cartão.

// ---- Cadastro ----

export const CreateDeviceRequestSchema = z.object({
  code: z.string().min(1).max(40),
  name: z.string().min(1).max(120),
});
export type CreateDeviceRequest = z.infer<typeof CreateDeviceRequestSchema>;

export const UpdateDeviceRequestSchema = CreateDeviceRequestSchema.partial();
export type UpdateDeviceRequest = z.infer<typeof UpdateDeviceRequestSchema>;

export const ListDevicesQuerySchema = z.object({
  archived: BooleanQueryParamSchema.optional(),
});
export type ListDevicesQuery = z.infer<typeof ListDevicesQuerySchema>;

export const DeviceSchema = z.object({
  id: z.string().uuid(),
  code: z.string(),
  name: z.string(),
  lastSeenAt: z.string().datetime().nullable(),
  cardCount: z.number().int().optional(),
  sensorCount: z.number().int().optional(),
  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime().optional(),
});
export type Device = z.infer<typeof DeviceSchema>;

export const CreatedDeviceResponseSchema = z.object({
  device: DeviceSchema,
  rawApiKey: z.string(),
});
export type CreatedDeviceResponse = z.infer<typeof CreatedDeviceResponseSchema>;

// ---- Ingestão em lote (consumido por — HTTP + bridge) ----

export const BatchCardReadingSchema = z.object({
  card: z.string().min(1),
  reading: z.string(),
});
export type BatchCardReading = z.infer<typeof BatchCardReadingSchema>;

export const BatchReadingsRequestSchema = z.object({
  ts: z.string().datetime(),
  readings: z.array(BatchCardReadingSchema).min(1),
});
export type BatchReadingsRequest = z.infer<typeof BatchReadingsRequestSchema>;

export const IngestBatchResponseSchema = z.object({
  accepted: z.number().int(),
  rejected: z.number().int(),
  byReason: z.record(z.string(), z.number().int()).optional(),
});
export type IngestBatchResponse = z.infer<typeof IngestBatchResponseSchema>;

// Header de credencial do CLP na ingestão (não cruza o wire como contrato de
// dados, mas centralizado aqui pela convenção: nenhuma rota declara `z` local).
export const DeviceKeyHeaderSchema = z.object({ "x-device-key": z.string().min(1) }).passthrough();
